import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
export function FAQ() {
  useDocumentMeta('Kjergaard Sports FAQ | Store Visits, Firearms, Classes & Location', 'Frequently asked questions about visiting Kjergaard Sports, our firearm selection, ammunition, classes, and store policies.');
  const faqs = [{
    q: 'Where is Kjergaard Sports located?',
    a: 'We are located at 1951 200th Avenue, Lake Benton, Minnesota 56149. We are a rural destination store, and many customers drive long distances to visit us.'
  }, {
    q: 'Do you sell products directly through this website?',
    a: 'No. Kjergaard Sports does not conduct sales directly through this website. This site is for business information only.'
  }, {
    q: 'Can I call about current in-store availability?',
    a: 'Yes, please call us at 507-368-4696 to check current availability for specific firearms, ammunition, or gear.'
  }, {
    q: 'Do you carry new and used firearms?',
    a: 'Yes, we have approximately 5,000 new and used firearms on hand, catering to hunters, sport shooters, and collectors.'
  }, {
    q: 'Do you carry ammunition?',
    a: 'Yes, we stock a large selection of ammunition for hunting, target shooting, and personal defense. Call for current caliber availability.'
  }, {
    q: 'Do you carry optics?',
    a: 'Yes, we carry scopes, binoculars, spotting scopes, and rangefinders.'
  }, {
    q: 'Do you carry reloading supplies?',
    a: 'Yes, we stock bullets, powder, primers, presses, and reloading tools.'
  }, {
    q: 'Do you have safes and accessories?',
    a: 'Yes, we carry gun safes, cases, holsters, cleaning supplies, and other shooting accessories.'
  }, {
    q: 'Do you offer Minnesota Permit to Carry classes?',
    a: 'Yes, we periodically host classes. Please call the store or check our Facebook page for upcoming dates.'
  }, {
    q: 'Where can I find current hours and event updates?',
    a: 'Please call the store or check our Facebook page for current hours, class dates, and store updates.'
  }, {
    q: 'How do firearm sales and transfers work?',
    a: 'All firearm-related sales and transfers are handled in-store and in accordance with applicable federal, state, and local laws. Requirements vary. Please call the store and consult applicable laws.'
  }, {
    q: 'Can out-of-state customers visit?',
    a: 'Yes, out-of-state customers are welcome to visit and browse. However, firearm purchases and transfers are subject to federal and state laws. Please call the store with specific questions regarding out-of-state transactions.'
  }];
  return <div data-id="element-249">
      <PageHero title="Frequently Asked Questions" image="https://drwzpk38qkpfb.cloudfront.net/www.ksportsllc.com/uploaded/images/Store.jpg?opt=w3" alt="Inside Kjergaard Sports sporting goods store" data-id="element-250" />

      <section className="py-20 bg-brand-offwhite bg-texture" data-id="element-251">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-252">
          <div className="space-y-6" data-id="element-253">
            {faqs.map((faq, index) => <div key={index} className="bg-brand-bone p-8 rounded-sm border border-brand-cream" data-id="element-254">
                <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-255">
                  {faq.q}
                </h3>
                <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-256">
                  {faq.a}
                </p>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}